import { h, Fragment } from 'preact';
import { useState } from 'preact/hooks';
import { getCountryFromCountryCode } from '../../lib/Country';
import I18n from '../../lib/I18n';
import CountryCallingCodeSelect from '../../molecules/CountryCallingCodeSelect';
import { availIncentiveCouponCode } from '../../lib/Coupon';

import { setIdentity, validatePhone } from '../../lib/Identity';
import './index.less';
import { parseAndValidateNumber } from '../../lib/Utils';

export default ({ updateStep, buttonStyle, closeDialog, setCouponCode }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState('');
  const [invalidName, setInvalidName] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(getCountryFromCountryCode('IN'));
  const [nationalNumber, setNationalNumber] = useState(null);
  const [nationalNumberInvalid, setNationalNumberInvalid] = useState(false);

  const onCountryChange = event => {
    event.stopPropagation();
    setSelectedCountry(JSON.parse(event.target.value));
  };

  const onNumberChange = event => {
    const { value } = event.target;

    const stringNum = parseAndValidateNumber(value, {
      decimal: false,
      blankStringValid: true
    });
    const valueNum = Number(stringNum);

    if (stringNum === null || Number.isNaN(valueNum)) {
      event.target.value = nationalNumber;
      return;
    }
    setNationalNumber(valueNum);
    setNationalNumberInvalid(false);
    event.target.value = stringNum;
  };

  const onNameChange = event => {
    event.stopPropagation();
    setName(event.target.value);
    setInvalidName(false);
  };

  const submit = event => {
    event.preventDefault();
    const nationalNumberRaw = nationalNumber;

    if (!name.trim() || !nationalNumberRaw) {
      setInvalidName(!name.trim());
      setNationalNumberInvalid(!nationalNumberRaw);
      return;
    }

    setIsLoading(true);

    const tempNationalNumber = nationalNumberRaw
      .toString()
      .trim()
      .split(' ')
      .join('')
      .split('-')
      .join('');

    const callingCode = selectedCountry.callingCode.split(' ').join('');

    const e164Number = callingCode + tempNationalNumber;

    validatePhone(e164Number).then(result => {
      const { e164Number: proper164Number, validated } = result;

      if (!validated) {
        setNationalNumberInvalid(true);
        setIsLoading(false);
        return;
      }

      const nameTrimed = name.trim();
      availIncentiveCouponCode({ name: nameTrimed, phone: proper164Number })
        .then(response => {
          if (!response) {
            setIsLoading(false);
            alert(I18n.t('SORRY_NO_COUPON_FOUND'));
            return closeDialog();
          }
          setCouponCode(response);
          return setIdentity({
            name: nameTrimed,
            phone: proper164Number,
            phoneVerified: false
          });
        })
        .then(() => {
          setIsLoading(false);
          updateStep('2a');
        })
        .catch(() => {
          setIsLoading(false);
        });
    });
  };

  const onCloseForm = event => {
    event.preventDefault();
    if (isLoading) {
      return;
    }
    updateStep('2b');
  };

  return (
    <Fragment>
      <div className="offer-title">{I18n.t('SPECIAL_OFFER_FOR_YOU')}</div>
      <div className="offer-subtitle">{I18n.t('GET_TEN_PERCENT_OFF_COUPON_NOW')}</div>
      <div className="offer-input-container">
        {I18n.t('NAME')}
        <input
          className={`field-with-border common-field ${invalidName ? 'invalidValue' : ''}`}
          placeholder={I18n.t('REQUEST_IDENTITY_CHAT_ENTER_NAME_PLACEHOLDER')}
          readOnly={isLoading}
          value={name}
          onInput={onNameChange}
        />
      </div>
      <div className="offer-input-container">
        {I18n.t('PHONE')}
        <div
          className={`field-with-border common-field ${
            nationalNumberInvalid ? 'invalidValue' : ''
          }`}
        >
          <CountryCallingCodeSelect
            containerClassName="country"
            containerClassName={'custom-code-container'}
            selectedCountry={selectedCountry}
            onCountryChange={onCountryChange}
          />
          <input
            type="tel"
            className={'phone-input'}
            placeholder={I18n.t('PHONE')}
            readOnly={isLoading}
            value={nationalNumber}
            onInput={onNumberChange}
          />
        </div>
      </div>
      <button
        onClick={submit}
        disabled={isLoading}
        className="get-off-button common-field"
        style={{ ...buttonStyle, color: buttonStyle.textColor }}
      >
        {isLoading ? <div className="loader" /> : I18n.t('GET_TEN_PERCENT_OFF')}
      </button>
      <div className="close" onClick={onCloseForm}>
        {I18n.t('NO_TEN_PERCENT_OFF')}
      </div>
    </Fragment>
  );
};
